import { openCookieSettings } from './CookieConsent';
import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock, Star } from 'lucide-react';
import { COMPANY, SERVICES, BRAND_LOGO } from '../mock';

const Footer = () => {
  return (
    <footer className="bg-[color:var(--mv-navy)] text-white mt-24">
      <div className="container-xl py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
        <div>
          <div className="flex items-center gap-2.5">
            <img src={BRAND_LOGO} alt="Move Van Ltd" className="h-14 w-auto bg-white rounded-md p-1.5" />
          </div>
          <p className="mt-5 text-white/70 leading-relaxed">
            Removals, man and van, furniture delivery and clearances across London and the surrounding counties.
          </p>

        </div>

        <div>
          <h4 className="font-display font-bold text-lg uppercase tracking-wider mb-5">Our Services</h4>
          <ul className="space-y-2.5 text-white/75">
            {SERVICES.slice(0, 6).map((s) => (
              <li key={s.id}>
                <Link to="/services" className="hover:text-[color:var(--mv-orange-2)] transition-colors">{s.title}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-display font-bold text-lg uppercase tracking-wider mb-5">Quick Links</h4>
          <ul className="space-y-2.5 text-white/75">
            <li><Link to="/" className="hover:text-[color:var(--mv-orange-2)]">Home</Link></li>
            <li><Link to="/services" className="hover:text-[color:var(--mv-orange-2)]">Services</Link></li>
            <li><Link to="/prices" className="hover:text-[color:var(--mv-orange-2)]">Prices</Link></li>
            <li><Link to="/about" className="hover:text-[color:var(--mv-orange-2)]">About Us</Link></li>
            <li><Link to="/contact" className="hover:text-[color:var(--mv-orange-2)]">Contact</Link></li>
            <li><Link to="/fly-tipping" className="hover:text-[color:var(--mv-orange-2)]" data-testid="footer-flytipping-link">Report fly-tipping</Link></li>
            <li><a href={COMPANY.tidePayUrl} target="_blank" rel="noreferrer" className="hover:text-[color:var(--mv-orange-2)]" data-testid="footer-tide-link">Pay with Tide</a></li>
            <li>
              <a
                href="https://g.page/r/CS3poVk4PH2vEAE/review?utm_source=gbp&utm_medium=reviews&utm_campaign=qr"
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-1.5 hover:text-[color:var(--mv-orange-2)]"
              >
                <Star className="w-3.5 h-3.5 fill-[color:var(--mv-yellow)] text-[color:var(--mv-yellow)]" />
                Leave a Review
              </a>
            </li>
            <li><Link to="/terms" className="hover:text-[color:var(--mv-orange-2)]">Terms &amp; Conditions</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display font-bold text-lg uppercase tracking-wider mb-5">Get in Touch</h4>
          <ul className="space-y-4 text-white/80">
            <li className="flex gap-3">
              <Phone className="w-5 h-5 shrink-0 text-[color:var(--mv-orange-2)] mt-0.5" />
              <div>
                <a href={`tel:${COMPANY.phone.replace(/\s/g, '')}`} className="block font-semibold hover:text-[color:var(--mv-orange-2)]">{COMPANY.phone}</a>
              </div>
            </li>
            <li className="flex gap-3">
              <Mail className="w-5 h-5 shrink-0 text-[color:var(--mv-orange-2)] mt-0.5" />
              <a href={`mailto:${COMPANY.email}`} className="hover:text-[color:var(--mv-orange-2)]">{COMPANY.email}</a>
            </li>
            <li className="flex gap-3">
              <MapPin className="w-5 h-5 shrink-0 text-[color:var(--mv-orange-2)] mt-0.5" />
              <span>{COMPANY.address}</span>
            </li>
            <li className="flex gap-3">
              <Clock className="w-5 h-5 shrink-0 text-[color:var(--mv-orange-2)] mt-0.5" />
              <span>{COMPANY.hours}</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container-xl py-5 flex flex-col md:flex-row items-center justify-between gap-3 text-sm text-white/60">
          <p>© {new Date().getFullYear()} Move Van Ltd. All rights reserved.</p>
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-2">
            <Link to="/privacy" className="hover:text-white" data-testid="footer-privacy-link">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-white">Terms &amp; Conditions</Link>
            <Link to="/cookies" className="hover:text-white" data-testid="footer-cookies-link">Cookies</Link>
            <button type="button" onClick={openCookieSettings} className="hover:text-white" data-testid="footer-cookie-settings">Cookie settings</button>
            <Link to="/admin" className="hover:text-white" data-testid="footer-owner-link">Owner</Link>
            <Link to="/driver" className="hover:text-white" data-testid="footer-driver-link">Driver</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
